"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMergedIndexRanges = void 0;
const getMergedIndexRanges = indexRanges => {
  indexRanges.sort((a, b) => {
    if (a[0] === undefined || b[0] === undefined) {
      return 0;
    }
    return a[0] - b[0];
  });
  const mergedRanges = [];
  let [previousRangeStart, previousRangeEnd] = indexRanges[0] ?? [];

  // Merges index intervals like [[10, 20], [19, 20], [20, 40]] into [[10, 40]]
  for (let i = 1; i < indexRanges.length; i++) {
    const [currentRangeStart, currentRangeEnd] = indexRanges[i] ?? [];
    if (currentRangeStart === undefined || currentRangeEnd === undefined || previousRangeStart === undefined || previousRangeEnd === undefined) {
      continue;
    }
    if (previousRangeEnd >= currentRangeStart) {
      previousRangeEnd = Math.max(previousRangeEnd, currentRangeEnd);
    } else {
      mergedRanges.push([previousRangeStart, previousRangeEnd]);
      [previousRangeStart, previousRangeEnd] = indexRanges[i] ?? [];
    }
  }
  if (previousRangeStart !== undefined && previousRangeEnd !== undefined) {
    mergedRanges.push([previousRangeStart, previousRangeEnd]);
  }
  return mergedRanges;
};
exports.getMergedIndexRanges = getMergedIndexRanges;